/* =================== BLOCOS HOME =================== */
jQuery(document).ready(function ($) {
  $('.carrosel-anuncios-exclusivos').slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    infinite: true,
    autoplay: false,
    adaptiveheight: false,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 760,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
});

// Carrosel de fotos
(function () {
  'use strict';

  $('.anuncio-exclusivo-fotos').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    infinite: true,
    autoplay: false,
    swipe: false,
  });
})();
